<app-nav-bar></app-nav-bar>

<section class="pricing-section section-padding">
  <div class="container">
    <div class="section-head">
      <span class="sub-title">Upgrade Your Love Journey</span>
      <h2>Choose the Perfect <span class="heading-gradient">Plan</span></h2>
      <p>Pick a plan and unlock premium features that bring you closer to real, meaningful connections.</p>
    </div>

    <div class="pricing-grid">
      @for (plan of plans; track plan.name) {
      <div class="pricing-card" [class.popular-card]="plan.popular">
        @if (plan.popular) {
        <span class="popular-badge">{{ plan.badge }}</span>
        }

        <div class="card-header">
          <h3>{{ plan.name }}</h3>
          <div class="price-container">
            <span class="price-amount">{{ plan.price }}</span>
            <span class="price-period">{{ plan.period }}</span>
          </div>
        </div>

        <div class="card-features">
          <ul>
            @for (feature of plan.features; track feature) {
            <li>
              <span class="check-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              {{ feature }}
            </li>
            }
          </ul>
        </div>

        <div class="card-action">
          <button class="upgrade-btn" (click)="selectPlan(plan)">
            Get Started
          </button>
        </div>
      </div>
      }
    </div>

    <div class="pricing-faq">
      <h3 class="faq-title text-center">Frequently Asked Questions</h3>
      <div class="faq-grid">
        <div class="faq-item">
          <h4>How do I upgrade my account?</h4>
          <p>Click "Get Started" on any plan, sign in or sign up to your account, and follow the simple payment process
            securely powered by Stripe.</p>
        </div>
        <div class="faq-item">
          <h4>Can I cancel my subscription?</h4>
          <p>Yes, you can cancel your subscription at any time directly through the "My Subscription" settings screen in
            the application.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer-banner></app-footer-banner>